import { Link, LinkMap, StoryblokLinkNode } from './types';

export const createMapFromId = (list: StoryblokLinkNode[]): LinkMap => list.reduce((a, v) => ({ ...a, [v.id]: v }), {});

export const isTypeUrl = (link: Link): boolean => link.linktype === 'url';
export const isTypeAsset = (link: Link): boolean => link.linktype === 'asset';
export const mockLink = {
  url: '',
  cached_url: '',
  linktype: '',
  story: {
    url: '',
  },
};

export const isExternalUrl = (link: Link): boolean => link.url !== '';

export const encodeUrl = (link: Link = mockLink): string => encodeURI(link.url || link.story?.url || '');

export const isHttpLink = (link: Link): boolean => encodeUrl(link).startsWith('http');

export const isCurrentPage = (link: Link): boolean => `${global.window?.location.pathname}/` === `/${encodeUrl(link)}`;
